import { AT_RESET } from './constants';
import { IResetAction } from './types';

export const resetAction = (
): IResetAction => {
    return {
        type: AT_RESET
    };
};
